import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';

@Injectable({
    providedIn: 'root'
})
export class Casautomation {

    ApiUrlSC: any = {
        generateTransactionUrl: `${environment.mfOnlineUrl}/api/v1/SmMfCenter/generate-transaction-id`,
        generateTokenPanEmail: `${environment.mfOnlineUrl}/api/v1/auth/generate-Jwt-Token-Pan-Email`,
        getFetchStatusWealthLens: `${environment.mfOnlineUrl}/api/v1/SmMfCenter/get-mf-import-status-pan-wealthlens`,
        getFetchStatusMfCampaign: `${environment.mfOnlineUrl}/api/v1/SmMfCenter/get-mf-import-status-pan-mfCampaign`,
        generateTokenUrl: `${environment.mfOnlineUrl}/api/v1/auth/generate-jwt-token-smallcase`,
        insertMfcampaignleadURL: `${environment.mfOnlineUrl}/api/v1/mfcampaign/mf-campaign-lead`,
        // generateTransactionUrl: `${environment.smallCaseUrl}/gateway/bajajcapital-mf/transaction`,
        generateOtpUrl: `${environment.mfOnlineUrl}/api/v1/SmMfCenter/generateOtp`,
        verifyOtpURL: `${environment.mfOnlineUrl}/api/v1/SmMfCenter/verifyOtp`,
        wealthLensReportDataUrl: `${environment.mfOnlineUrl}/api/v1/WealthLensReport/Wealth-lens-report-data`,
        verifyWealthLensOtpUrl: `${environment.mfOnlineUrl}/api/v1/SmMfCenter/verify-otp`,
        // wealthLensLSQLeadUrl: `${environment.mfOnlineUrl}/api/opportunities`,
    }

    constructor(
        private http: HttpClient,
    ) {

    }

    httpOptions = {
        headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
    };

    private jsonHeaders(authToken?: string): HttpHeaders {
        let headers = new HttpHeaders({
            "accept": "application/json",
            "content-type": "application/json"
        });
        if (authToken) {
            headers = headers.set("Authorization", `Bearer ${authToken}`);
        }
        return headers;
    }

    generateTokenByPanEmail(payload: any) {
        return this.http.post(
            this.ApiUrlSC['generateTokenPanEmail'],
            payload,
            { headers: this.jsonHeaders() }
        );
    }
    getFetchStatus(payload: any, authToken?: string) {
        return this.http.post(
            this.ApiUrlSC['getFetchStatusWealthLens'],
            payload,
            { headers: this.jsonHeaders(authToken) }
        );
    }
    getFetchStatusMfCampaign(payload: any, authToken?: string) {
        return this.http.post(
            this.ApiUrlSC['getFetchStatusMfCampaign'],
            payload,
            { headers: this.jsonHeaders(authToken) }
        );
    }
    generateTokenSm(authToken?: string) {
        return this.http.get(
            this.ApiUrlSC['generateTokenUrl'],
            { headers: this.jsonHeaders(authToken) }
        );
    }
    generateTransactionSm(payload: any, authToken?: string) {
        return this.http.post(
            this.ApiUrlSC['generateTransactionUrl'],
            payload,
            { headers: this.jsonHeaders(authToken) }
        );
    }
    generateOtpSm(payload: any, authToken?: string) {
        return this.http.post(
            this.ApiUrlSC['generateOtpUrl'],
            payload,
            { headers: this.jsonHeaders(authToken) }
        );
    }
    verifyOtpURL(payload: any) {
        return this.http.post(
            this.ApiUrlSC['verifyOtpURL'],
            payload,
            { headers: this.jsonHeaders() }
        );
    }
    insertMfcampaignlead(payload: any, authToken?: string) {
        return this.http.post(
            this.ApiUrlSC['insertMfcampaignleadURL'],
            payload,
            { headers: this.jsonHeaders(authToken) }
        );
    }

    getWealthLensReportData(payload: { pan: string; reportType: string }, authToken?: string) {
        return this.http.post(
            this.ApiUrlSC['wealthLensReportDataUrl'],
            payload,
            { headers: this.jsonHeaders(authToken) }
        );
    }

    verifyWealthLensOTP(payload: any, authToken?: string) {
        return this.http.post(
            this.ApiUrlSC['verifyWealthLensOtpUrl'],
            payload,
            { headers: this.jsonHeaders(authToken) }
        );
    }

    
}
